/**
 * Email Validator
 * Validates email addresses
 */

export class EmailValidator {
  /**
   * Validates an email address
   * @param email - Email string
   * @returns true if valid, false otherwise
   */
  static isValid(email: string): boolean {
    if (!email) return false;

    // RFC 5322 compliant email regex (simplified but robust)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Basic format check
    if (!emailRegex.test(email)) return false;

    // Additional validations
    const parts = email.split('@');
    if (parts.length !== 2) return false;

    const [localPart, domain] = parts;

    // Local part validations
    if (localPart.length === 0 || localPart.length > 64) return false;
    if (localPart.startsWith('.') || localPart.endsWith('.')) return false;
    if (localPart.includes('..')) return false;

    // Domain validations
    if (domain.length === 0 || domain.length > 255) return false;
    if (domain.startsWith('.') || domain.endsWith('.')) return false;
    if (domain.includes('..')) return false;

    // Check if domain has at least one dot
    if (!domain.includes('.')) return false;

    // Check domain extension
    const domainParts = domain.split('.');
    const extension = domainParts[domainParts.length - 1];
    if (extension.length < 2) return false;

    return true;
  }

  /**
   * Gets error message for invalid email
   */
  static getErrorMessage(): string {
    return 'E-mail inválido';
  }
}
